import React, { useState, MouseEvent, useEffect } from 'react';
import {
  Button,
  FormControlLabel,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  Typography,
  Checkbox,
  Tooltip,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../../assets/images/userProfile.svg';
import audiLogDate from '../../../../assets/images/AudiLogDate.svg';
import audiLogUser from '../../../../assets/images/AudiLogUser.svg';
import audiLogEvent from '../../../../assets/images/AudiLogEvent.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import PaginationComponent from '../../../../components/Pagination';
import createAxiosInstance from '../../../../api';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import { closeBlackIcon } from '../../../../assets/images';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useSelector, useDispatch } from 'react-redux';
import { setAllUserListAction } from '../../../../stores/actionTypes/userActions';
import { setGlobalAuditlogListAction } from '../../../../stores/actionTypes/auditlogActions';
import { format } from 'date-fns';
import { startOfMonth, endOfMonth } from 'date-fns';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
}

const AudiLog: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('globalAudit::list');

  const canUserListPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('users::list');

  const canRolelistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['globalAudit::list'] || ''}</li>
        <li>{ErrorMessage['roles::list'] || ''}</li>
        <li>{ErrorMessage['users::list'] || ''}</li>
      </ul>
    </section>
  );

  interface UserDataList {
    userID: string;
    userName: string;
    firstName: string;
    lastName: string;
    avatar: string;
  }

  const EventDatas: string[] = [
    'Create Role',
    'Update Role',
    'Delete Role',
    'Create User',
    'Update User',
    'User password update',
    'User status change',
    'Create Controller',
    'Update Controller',
    'Delete Controller',
    'Create Category',
    'Create Sub Category',
    'Delete Category',
    'Delete Sub Category',
    'Create Equipment',
    'Update Equipment',
    'Delete Equipment',
    'Create Unit',
    'Update Unit',
    'Delete Unit',
    'Assign Inventory',
    'Ready to Dispatch',
    'Update Subscription',
  ];

  const { allUsers } = useSelector((state: any) => state.user);
  const { globalauditlogList } = useSelector((state: any) => state.auditlog);
  const dispatch = useDispatch();
  interface Filter {
    roleIDs: string[];
  }
  interface Role {
    userID?: string;
    event?: string;
    eventDescription?: string;
    eventTime?: string;
    avatar?: string;
    userName?: string;
  }

  const axiosInstance = createAxiosInstance();
  const [auditdata, setAuditdata] = useState<Role[]>([]);
  const [roleerror, setroleerror] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [initialEventData, setInitialEventData] =
    useState<string[]>(EventDatas);
  const [selectedDate, setSelectedDate] = useState<string[]>(['Today']);
  const [userAnchorEl, setUserAnchorEl] = useState<null | HTMLElement>(null);
  const [dateAnchorEl, setDateAnchorEl] = useState<null | HTMLElement>(null);
  const [eventAnchorEl, setEventAnchorEl] = useState<null | HTMLElement>(null);
  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedusername, setSelectedusername] = useState<string[]>([]);
  const [userData, setUserdata] = useState<any[]>([]);
  const [initialUserData, setInitialUserData] = useState<string[]>([]);
  const [eventNameQuery, setEventNameQuery] = useState<string>('');
  const [userNameQuery, setUserNameQuery] = useState<string>('');
  const [filteredEvent, setFilteredEvent] = useState<string[]>(EventDatas);
  const [filterPayload, setFilterPayload] = useState<null | any>(null);
  const [initialApiCall, setInitialApiCall] = useState(false);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [seeMoreUserIndex, setSeeMoreUserIndex] = useState<number>(2);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    filterPayload
      ? fetchFilterDate(filterPayload, page, rowsPerPage)
      : getAuditData(page, rowsPerPage, eventNameQuery);
  };

  const startToday = new Date();
  startToday.setHours(0, 0, 0, 0);

  const startOfCurrentMonth = startOfMonth(new Date());
  const endOfCurrentMonth = endOfMonth(new Date());

  const [selectionRange, setSelectionRange] = useState({
    startDate: startOfCurrentMonth,
    endDate: endOfCurrentMonth,
    key: 'selection',
  });

  const changeFormat = (date: number | Date) => {
    return format(date, 'MMM d, yyyy');
  };

  const handleSelect = (ranges: any) => {
    setSelectionRange({
      ...ranges.selection,
      startDate: new Date(ranges.selection.startDate.setHours(0, 0, 0, 0)), // Reset start to 00:00:00
      endDate: new Date(ranges.selection.endDate.setHours(23, 59, 59, 999)), // Reset end to 23:59:59
    });
    setCurrentPage(1);
  };
  const handleRowsPerPageChange = (value: number) => {
    filterPayload
      ? fetchFilterDate(filterPayload, currentPage - 1, value)
      : getAuditData(currentPage - 1, value);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (initialApiCall) {
      // Define the initial payload object
      const payload = {
        from: selectionRange.startDate.toISOString(),
        to: selectionRange.endDate.toISOString(),
      };

      if (
        // selectedDate?.length > 0 ||
        selectionRange ||
        selectedusername.length > 0 ||
        selectedData.length > 0 ||
        initialUserData.length > 0
      ) {
        fetchFilterDate(payload);
        setFilterPayload(payload);
      } else {
        setFilterPayload(null);
      }
    }
    setSeeMoreIndex(selectedData?.length);
    setSeeMoreUserIndex(selectedusername?.length);
  }, [
    selectedDate,
    selectedData,
    selectedusername,
    selectionRange,
    initialUserData,
  ]);

  const fetchFilterDate = async (
    payload?: any,
    pagenumber?: number,
    row_perpage?: number,
  ) => {
    if (canlistPermission && canUserListPermission && canRolelistPermission) {
      await axiosInstance
        .post('/globalAuditList', {
          from: payload.from ? payload.from : null,
          to: payload.from ? payload.to : null,
          // eventNames:
          //   initialEventData?.length > 0
          //     ? initialEventData
          //     : selectedData
          //       ? selectedData
          //       : '',
          eventNames: selectedData,
          // userIDs:
          //   initialUserData?.length > 0 ? initialUserData : selectedusername,
          userIDs: selectedusername,
          limit: row_perpage ? row_perpage : rowsPerPage,
          offset: pagenumber
            ? (pagenumber - 1) * rowsPerPage
            : (currentPage - 1) * rowsPerPage,
        })
        .then((response) => {
          setAuditdata(response.data.data);
          dispatch(setGlobalAuditlogListAction(response?.data?.data));

          const uniqueEventNames = [
            ...new Set(response.data.data.map((item: any) => item.event)),
          ];

          // setFilteredData(uniqueEventNames);
          // setFilteredData(['Login Event', 'Create Role', 'Reset Event']);

          setroleerror(false);

          setTotalPages(
            Math.ceil(
              response.data.count / (row_perpage ? row_perpage : rowsPerPage),
            ),
          );
        })
        .catch((error) => {
          setAuditdata([]);
          setroleerror(true);
        });
    }
  };

  const handleChange = (username: any): void => {
    setInitialEventData([]);
    if (username === 'AllEvent') {
      selectedData.length === EventDatas.length
        ? setSelectedData([])
        : setSelectedData(EventDatas);
      setCurrentPage(1);
      return;
    }
    if (username) {
      if (selectedData.includes(username)) {
        const updatedData = selectedData.filter(
          (item: any) => item !== username,
        );
        setSelectedData(updatedData);
      } else {
        const adddata = [...selectedData, username];
        const uniqueEventNames = [...new Set(adddata)];
        setSelectedData(uniqueEventNames);
      }
    } else {
      return;
    }
    setCurrentPage(1);
  };

  const handleuser = (userId: string): void => {
    setInitialUserData([]);
    if (userId === 'AllUser') {
      const updateUser = userData?.map((user) => user?.userID);
      selectedusername.length == filteredData.length
        ? setSelectedusername([])
        : setSelectedusername(updateUser);
      setCurrentPage(1);
      return;
    }
    if (selectedusername.includes(userId)) {
      const updateUser = selectedusername?.filter((user) => user !== userId);
      setSelectedusername(updateUser);
    } else {
      setSelectedusername([...selectedusername, userId]);
    }
    setCurrentPage(1);
  };

  const getUserName = (userId: string) => {
    const findUser = userData?.find((data) => data?.userID === userId);
    return findUser?.firstName && findUser?.lastName
      ? findUser?.firstName + ' ' + findUser?.lastName
      : userId;
  };

  const handleUserClick = (event: MouseEvent<HTMLElement>): void => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleDateClick = (event: MouseEvent<HTMLElement>): void => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleEventClick = (event: MouseEvent<HTMLElement>): void => {
    setEventAnchorEl(event.currentTarget);
  };

  const handleUserClose = () => {
    setUserAnchorEl(null);
  };
  const handleDateClose = () => {
    setDateAnchorEl(null);
  };
  const handleEventClose = () => {
    setEventAnchorEl(null);
  };

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = userData?.filter((user) =>
      `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
    setUserNameQuery(event.target.value);
  };

  const handleEventNameSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value;
    setEventNameQuery(query);
    const filtered = EventDatas.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase()),
    );
    setFilteredEvent(filtered);
  };
  function formatDate(isoDate: any) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  function formatTime(isoDate: any): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
  const getAuditData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters: Filter[] | undefined = [],
    // sort: Sort | undefined = { orderBy: 'name', order: 'asc' },
  ) => {
    const setfilter = filters?.length > 0 ? { roleIDs: filters } : {};

    await axiosInstance
      .post('/globalAuditList', {
        search: search,
        // sort: sort,
        filters: setfilter,
        limit: row_perpage ? row_perpage : rowsPerPage,
        offset: pagenumber
          ? (pagenumber - 1) * rowsPerPage
          : (currentPage - 1) * rowsPerPage,
      })
      .then((response) => {
        setAuditdata(response.data.data);
        dispatch(setGlobalAuditlogListAction(response?.data?.data));
        setTotalPages(
          Math.ceil(
            response.data.count / (row_perpage ? row_perpage : rowsPerPage),
          ),
        );
        setroleerror(false);
      })
      .catch(() => {
        setAuditdata([]);
        setroleerror(true);
      });
  };

  const getUserData = async () => {
    if (canlistPermission && canUserListPermission && canRolelistPermission) {
      await axiosInstance
        .post('/listUser', {})
        .then((response) => {
          if (response?.data?.data) {
            dispatch(setAllUserListAction(response?.data?.data));
            setUserdata(response?.data?.data);
            setFilteredData(response?.data?.data);
            const updateUser = response?.data?.data?.map(
              (user: { userID: any }) => user?.userID,
            );
            setInitialUserData(updateUser);
            setInitialApiCall(true);
          }
        })
        .catch(() => {
          setUserdata([]);
          setFilteredData([]);
          setInitialApiCall(true);
        });
    }
  };

  useEffect(() => {
    if (allUsers?.length > 0) {
      setUserdata(allUsers);
      setFilteredData(allUsers);
      const updateUser = allUsers?.map((user: { userID: any }) => user?.userID);
      setInitialUserData(updateUser);
      setInitialApiCall(true);
    } else {
      getUserData();
    }
  }, [canlistPermission, canUserListPermission, canRolelistPermission]);

  useEffect(() => {
    if (!filterPayload && !(selectedDate?.length > 0)) {
      getAuditData();
    }
  }, [filterPayload]);

  const userOpen = Boolean(userAnchorEl);
  const userId = userOpen ? 'simple-popover' : undefined;
  const dateOpen = Boolean(dateAnchorEl);
  const dateId = dateOpen ? 'simple-popover' : undefined;
  const eventOpen = Boolean(eventAnchorEl);
  const eventId = eventOpen ? 'simple-popover' : undefined;

  return (
    <>
      {!canlistPermission ||
      !canUserListPermission ||
      !canRolelistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <div className="content  global_audilog user_management">
            <div className="global_audilog_header">
              <Button
                className="global_audilog_date-btn global_buttons"
                aria-describedby={dateId}
                onClick={handleDateClick}
              >
                <img src={audiLogDate} width={24} alt="date img" />
                <Typography>Period</Typography>
              </Button>
              <div>
                <Button
                  className={
                    selectedusername?.length > 0
                      ? 'global_audilog_event_name-btn global_buttons global_buttons-active'
                      : 'global_audilog_event_name-btn global_buttons'
                  }
                  aria-describedby={userId}
                  onClick={handleUserClick}
                >
                  <img src={audiLogUser} width={24} alt="avater img" />
                  <Typography>User Name</Typography>
                  <div className="global_buttons-filtercount">
                    <p>{selectedusername?.length}</p>
                  </div>
                </Button>
                <div></div>
              </div>

              <Button
                className={
                  selectedData?.length > 0
                    ? 'global_audilog_event_name-btn global_buttons global_buttons-active'
                    : 'global_audilog_event_name-btn global_buttons'
                }
                aria-describedby={eventId}
                onClick={handleEventClick}
              >
                <img src={audiLogEvent} width={24} alt="event img" />
                <Typography>Event Name</Typography>
                <div className="global_buttons-filtercount">
                  <p>{selectedData?.length}</p>
                </div>
              </Button>
            </div>
            <section className="global_buttons_filtered-name">
              <div className="auditlog_date_range">
                {changeFormat(selectionRange?.startDate) +
                  ' - ' +
                  changeFormat(selectionRange?.endDate)}
              </div>
              <div>
                {selectedData?.slice(0, seeMoreIndex)?.map((event, index) => (
                  <div key={index} className="filterlist">
                    <p>{event}</p>
                    <Button onClick={() => handleChange(event)}>
                      <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                    </Button>
                  </div>
                ))}
                {selectedData?.length > 2 && seeMoreIndex === 2 && (
                  <div className="see_more_data">
                    <Button
                      onClick={() => setSeeMoreIndex(selectedData?.length)}
                    >{`+${selectedData?.length - 2} More Event`}</Button>
                  </div>
                )}
                {selectedData?.length > 2 && seeMoreIndex !== 2 && (
                  <div className="see_more_data">
                    <Button onClick={() => setSeeMoreIndex(2)}>
                      show less Event
                    </Button>
                  </div>
                )}
              </div>
              <div>
                {selectedusername
                  ?.slice(0, seeMoreUserIndex)
                  ?.map((user, index) => (
                    <div key={index} className="filterlist">
                      <p>{getUserName(user)}</p>
                      <Button onClick={() => handleuser(user)}>
                        <img
                          src={closeBlackIcon}
                          alt="Delete Icon"
                          width={13}
                        />
                      </Button>
                    </div>
                  ))}
                {selectedusername?.length > 2 && seeMoreUserIndex === 2 && (
                  <div className="see_more_data">
                    <Button
                      onClick={() =>
                        setSeeMoreUserIndex(selectedusername?.length)
                      }
                    >{`+${selectedusername?.length - 2} More User`}</Button>
                  </div>
                )}
                {selectedusername?.length > 2 && seeMoreUserIndex !== 2 && (
                  <div className="see_more_data">
                    <Button onClick={() => setSeeMoreUserIndex(2)}>
                      show less User
                    </Button>
                  </div>
                )}
              </div>
            </section>

            <TableContainer
              className="global_audilog_table-container"
              component={Paper}
            >
              <Table>
                <TableHead className="global_audilog_table-heading">
                  <TableRow>
                    <TableCell className="global_audilog_event-name">
                      <Typography>Event Name</Typography>
                    </TableCell>
                    <TableCell className="global_audilog_user-name">
                      <Typography>User Name</Typography>
                    </TableCell>
                    <TableCell className="global_audilog_update">
                      <Typography>Event Description</Typography>
                    </TableCell>
                    <TableCell className="global_audilog_update">
                      <Typography>Last Updated</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {auditdata?.map((user, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Typography>{user?.event}</Typography>
                      </TableCell>
                      <TableCell>
                        <div className="global_audilog_name-data">
                          <img
                            src={user?.avatar ? user?.avatar : userProfile}
                            width={24}
                            alt="User Profile"
                          />{' '}
                          <Typography>
                            {user?.userName ? user?.userName : ''}
                          </Typography>
                        </div>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {user?.eventDescription &&
                          user?.eventDescription?.length > 30 ? (
                            <Tooltip
                              title={
                                user?.eventDescription && (
                                  <>
                                    {user.eventDescription
                                      .split(',')
                                      .map((part, index) => (
                                        <div key={index}>
                                          {part
                                            .split('.')
                                            .map((subPart, subIndex) => (
                                              <div key={subIndex}>
                                                {subPart}
                                              </div>
                                            ))}
                                        </div>
                                      ))}
                                  </>
                                )
                              }
                              arrow
                            >
                              <span>
                                {user?.eventDescription?.slice(0, 30)}....
                              </span>
                            </Tooltip>
                          ) : (
                            user?.eventDescription && (
                              <>
                                {user.eventDescription
                                  .split(',')
                                  .map((part, index) => (
                                    <div key={index}>
                                      {part
                                        .split('.')
                                        .map((subPart, subIndex) => (
                                          <div key={subIndex}>{subPart}</div>
                                        ))}
                                    </div>
                                  ))}
                              </>
                            )
                          )}

                          {/* {user?.eventDescription && (
                            <>
                              {user.eventDescription
                                .split(',')
                                .map((part, index) => (
                                  <div key={index}>
                                    {part
                                      .split('.')
                                      .map((subPart, subIndex) => (
                                        <div key={subIndex}>{subPart}</div>
                                      ))}
                                  </div>
                                ))}
                            </>
                          )} */}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>
                          {formatDate(user?.eventTime) +
                            '  ' +
                            formatTime(user.eventTime)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {!(auditdata?.length > 0) && (
              <div className="global_audilog-nodata">
                <img src={emptyFolter} alt="nodata" width="120" height="120" />
                <h3>No Record Found!</h3>
              </div>
            )}

            {auditdata?.length > 0 && (
              <PaginationComponent
                rowsPerPageOptions={[5, 10, 20, 30]}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                totalPages={totalPages}
              />
            )}

            <Popover
              className="popover-audit"
              id={dateId}
              open={dateOpen}
              anchorEl={dateAnchorEl}
              onClose={handleDateClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <div>
                <DateRangePicker
                  ranges={[selectionRange]}
                  onChange={handleSelect}
                />
              </div>
            </Popover>

            <Popover
              className="popover-audit"
              id={userId}
              open={userOpen}
              anchorEl={userAnchorEl}
              onClose={handleUserClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <div className="user_name-popover">
                <div className="user_name-popover-search">
                  <TextField
                    className="user_name-popover-search_input search-input"
                    variant="outlined"
                    placeholder="Search user"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    value={userNameQuery}
                    onChange={handleUserSearch}
                  />
                </div>
                <div
                  className={
                    selectedData.length == EventDatas.length
                      ? 'role-popover-checkbox role-popover-checkbox_active'
                      : 'role-popover-checkbox'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          filteredData.length > 0 &&
                          selectedusername.length === filteredData.length
                        }
                        indeterminate={
                          selectedusername.length > 0 &&
                          selectedusername.length < filteredData.length
                        }
                        onChange={() => {
                          handleuser('AllUser');
                        }}
                      />
                    }
                    label="Select All"
                  />
                </div>
                {filteredData.map((user, index) => (
                  <Button
                    key={index}
                    onClick={() => {
                      handleuser(user.userID);
                    }}
                    className={
                      selectedusername.includes(user.userID)
                        ? 'global_audilog_user user_checked'
                        : 'global_audilog_user'
                    }
                  >
                    <div className="global_audilog_user_profile">
                      <img
                        src={user?.avatar ? user?.avatar : userProfile}
                        width={24}
                        alt="User Profile"
                      />{' '}
                      <p>{`${user?.firstName} ${user?.lastName}`}</p>
                    </div>
                    {selectedusername?.includes(user.userID) && (
                      <IconButton className="iconButton">
                        <DoneIcon className="doneIcon" />
                      </IconButton>
                    )}
                  </Button>
                ))}
              </div>
            </Popover>

            <Popover
              className="popover-audit"
              id={eventId}
              open={eventOpen}
              anchorEl={eventAnchorEl}
              onClose={handleEventClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <div className="user_name-popover">
                <div className="user_name-popover-search">
                  <TextField
                    className="user_name-popover-search_input search-input"
                    variant="outlined"
                    placeholder="Search events"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    value={eventNameQuery}
                    onChange={handleEventNameSearchChange}
                  />
                </div>
                <div className="event-popover">
                  <div
                    className={
                      selectedData.length == EventDatas.length
                        ? 'role-popover-checkbox role-popover-checkbox_active'
                        : 'role-popover-checkbox'
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            EventDatas.length > 0 &&
                            selectedData.length === EventDatas.length
                          }
                          indeterminate={
                            selectedData.length > 0 &&
                            selectedData.length < EventDatas.length
                          }
                          onChange={() => {
                            handleChange('AllEvent');
                          }}
                        />
                      }
                      label="Select All"
                    />
                  </div>
                  {filteredEvent.map((user, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          selectedData.includes(user)
                            ? 'role-popover-checkbox role-popover-checkbox_active'
                            : 'role-popover-checkbox'
                        }
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedData.includes(user)}
                              onChange={() => {
                                handleChange(user);
                              }}
                            />
                          }
                          label={user}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </Popover>
          </div>
        </>
      )}
    </>
  );
};

export default AudiLog;
